import React, { FC } from "react";

import {
  useApisManagersAiGeneratedCompanyPostSummariesShow,
  useAiCustomizeSlideNavigation,
} from "~/hooks";

import {
  EmployeeLayout,
  EmployeeLayoutMainContent,
  EmployeeLayoutRightSidebar,
} from "~/components/layouts";
import { NoDataDisplay } from "~/components/organisms";

import { LabelWithTextArea, Loading } from "~/ui";

export const ManagersAiCustomizeCompanyPostSummariesShow: FC = () => {
  const { data, isLoading } =
    useApisManagersAiGeneratedCompanyPostSummariesShow();

  const { navigations } = useAiCustomizeSlideNavigation({
    selectedArray: [false, false, true],
  });

  const breadCrumbItems = [
    {
      label: "AIカスタマイズ",
      href: "/managers/ai_costomize/company_contexts",
    },
    {
      label: "投稿要約",
      href: "/managers/ai_costomize/company_post_summaries",
    },
  ];

  return (
    <EmployeeLayout withRightSidebar breadCrumbItems={breadCrumbItems}>
      <EmployeeLayoutMainContent navigations={navigations} withRightSidebar>
        <div className="space-y-4 mt-4">
          {isLoading ? (
            <Loading />
          ) : data?.aiGeneratedCompanyPostSummary ? (
            <div className="space-y-4">
              <div className="flex items-center gap-2">
                <p className="text-sm text-secondary-600">最終更新日</p>
                <p className="text-secondary-900">
                  {data.aiGeneratedCompanyPostSummary.createdAt}
                </p>
              </div>
              <LabelWithTextArea
                labelText="要約"
                name="summary"
                placeholder=""
                rows={15}
                value={data.aiGeneratedCompanyPostSummary.summary}
                disabled
              />
            </div>
          ) : (
            <NoDataDisplay message="作成されるまでしばらくお待ちください" />
          )}
        </div>
      </EmployeeLayoutMainContent>
      <EmployeeLayoutRightSidebar />
    </EmployeeLayout>
  );
};
